function PixelDataToJSON(value) {
    return {
        siteId: value.siteId,
        currency: value.currency || '',
        productShopIdentifiers: value.productShopIdentifiers || null,
        productShopIdentifier: value.productShopIdentifier || null,
        cartItemSummaryList: value.cartItemSummaryList === undefined
            ? []
            : value.cartItemSummaryList.map(PixelDataCartItemSummaryListToJSON),
        newCustomer: value.newCustomer || null,
        orderId: value.orderId || null,
        orderValueNet: value.orderValueNet || null,
        orderValueGross: value.orderValueGross || null,
    };
}
function PixelDataCartItemSummaryListToJSON(value) {
    return {
        shopIdentifier: value.shopIdentifier,
        variantId: value.variantId,
        netPrice: value.netPrice,
        categoryName: value.categoryName,
        quantity: value.quantity,
        articleName: value.articleName,
        grossPrice: value.grossPrice,
    };
}

export { PixelDataToJSON };
//# sourceMappingURL=PixelData.js.map
